export default "__VITE_ASSET__BXIMWr0S__"